import Header from "@commons/header";

import Column from "@components/column";
import Tab from "@components/tabs";
import React from "react";
import StoreListTable from "../StoreListTable";

const PendingStoreRequest = () => {
  const items: any = [
    {
      label: "Pending Stores",
      component: StoreListTable,
      props: { type: "pending" },
    },
    {
      label: "Denied Stores",
      component: StoreListTable,
      props: { type: "rejected" },
    },
  ];
  return (
    <Column>
      <Header title="New Joining Requests" />
      <Tab items={items} fitContent />
    </Column>
  );
};

export default PendingStoreRequest;
